@if (!slider.hidden) {
<div [ngClass]="autoSlidesPerViewClasses">
<!-- navigation buttons on the sides -->
@if(!isMobile && slider.navigation_type === 'side_arrows'){
<div class="swiper-button-group flex flex-row justify-between absolute top-[46%] select-none" [ngClass]="[slider.slide_type === 'banner'? 'w-[84%] left-[8%]': 'w-full']">
  <div [ngClass]="[uniqueId + '-prev', 'swiper-button-prev', 'rounded-full', 'flex', 'flex-row', 'justify-center', 'items-center', lightArrows ? 'bg-[#CCE8B5] border-[#CCE8B5]' : 'bg-e-dark-green text-e-reg-green']">
    <img class="h-4 w-7 rotate-180" alt="next slide" [src]="lightArrows ? './assets/images/icons/arrow-right.svg' : './assets/images/icons/chevron_reg_green.svg'" />
  </div>
  <div [ngClass]="[uniqueId + '-next', 'swiper-button-next', 'rounded-full', 'flex', 'flex-row', 'justify-center', 'items-center', 'mr-0', lightArrows ? 'bg-[#CCE8B5] border-[#CCE8B5]' : 'bg-e-dark-green text-e-reg-green']">
    <img class="h-4 w-7" alt="previous slide" [src]="lightArrows ? './assets/images/icons/arrow-right.svg' : './assets/images/icons/chevron_reg_green.svg'" />
  </div>
</div>
}


<div class="container-default p-0 md:p-6 flex flex-col md:flex-row justify-center max-w-full">
  <!-- This is a fixed slide, undouble later on -->
  @if(!!fixedBlock && !fixedBlock.hidden){
  <ng-container *ngTemplateOutlet="slideContent; context:{slide: fixedBlock, index:0, fixed:true}"></ng-container>
  }
  <swiper-container class="" [ngClass]="{'w-full md:w-1/2 xl:w-2/3': !!fixedBlock && !fixedBlock.hidden, 'max-w-full': !fixedBlock}" #swiperRef init="false">
    @for (slide of slider.slides;let i = $index; track i) {
    <swiper-slide>
      <ng-container *ngTemplateOutlet="slideContent; context:{slide: slide, index:i}"></ng-container>
    </swiper-slide>
    }
  </swiper-container>


</div>

<!-- If we need navigation buttons -->
@if(!isMobile && slider.navigation_type === 'arrows'){
<div class="flex flex-row justify-center items-center relative bottom-0 select-none">
  <div [ngClass]="[uniqueId + '-prev', 'swiper-button-prev', 'flex', 'flex-row', 'justify-center', 'items-center']">
    <img class="h-4 w-7 rotate-180" alt="next slide" src="./assets/images/icons/arrow_right.svg" />
  </div>
  <div [ngClass]="[uniqueId + '-next', 'swiper-button-next', 'flex', 'flex-row', 'justify-center', 'items-center']">
    <img class="h-4 w-7" alt="previous slide" src="./assets/images/icons/arrow_right.svg" />
  </div>
</div>
}

@if (slider?.caption) {
  <p class="md:text-right">{{ slider.caption }}</p>
}

<ng-template #slideContent let-slide="slide" let-index="index" let-fixed="fixed">
  @if(!!slide.main_image?.filename && slide.main_image_as_background ){
    <app-cms-image imageClass="mx-auto aspect-auto rounded-lg w-72"  [height]="imageNoResize ? null : 320" [image]="slide.main_image"></app-cms-image>
  }
  <div class="swiper-slide-container flex flex-col px-1 md:px-10 rounded-lg relative"
    [ngClass]="[
      (!!slide?.bg_color && !slide.main_image_as_background ? 'bg-' + slide.bg_color : '')
      ,(!!slide.main_image_as_background? 'justify-end absolute inset-0': '' )
      ,(slider.slide_type === 'banner' ? '' :'py-[30px]' )
      ,fixed? 'items-center justify-center md:mr-5 w-full md:w-1/2 xl:w-1/3': ' h-full'
  ]">
    @if(!!slide.main_image?.filename &&!slide.main_image_as_background ){
       <app-cms-image imageClass="inline-block mx-auto aspect-auto" class="my-[15px]" [style.height.px]="imageNoResize ? undefined : imageHeight" [height]="imageNoResize ? undefined : imageHeight" [image]="slide.main_image"></app-cms-image>
    }

    <div class="swiper-slide-title flex flex-row justify-center items-center text-center">

      @if (slider.show_numbers && !slide.hide_number) {
        <div
          [ngClass]="{'absolute top-5 left-0': !isMobile}"
          class="flex items-center justify-center min-h-8 min-w-8 rounded-full bg-e-dark-green text-e-reg-green mr-5">
          <span class="font-serif pt-1">{{ index + 1 }}</span>
        </div>
      }

      @if (slide?.title) {
        <div [ngClass]="'text-' + slide?.text_color" [innerHTML]="slide['title_rendered']"></div>
      }

      @for (block of slide.blocks; track block) {
        @switch (block.component) {
          @case('card'){
            <app-cms-card class="w-full" [removeMargin]="slider.slide_type ==='banner'" [card]="block"></app-cms-card>
            }@case ('CTA') {
            <app-cms-button [button]="block"></app-cms-button>
          }
        }
      }
    </div>
  </div>
</ng-template>
</div>
}